import { useTranslation } from "react-i18next";
import { Lead } from "../../models/Lead";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { ModalInformation } from "../ModalInformation";
import { EyeIcon } from "@heroicons/react/24/outline";
import { docDateFormat } from "../../utils/functions";
import { RoleEnum } from "../../enums/Role";
import { UpdateLeadPath } from "../../constants/Routes";

interface Props {
  info: {
    lead?: Lead,
    currentUser?: any,
    show: boolean
  };
  onClose: () => void;
}

export const LeadInformationModal : React.FC<Props> = ({
  info,
  onClose,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [canViewClient, setCanViewClient] = useState(false);

  useEffect(() => {
    if(info.lead !== undefined && info.currentUser !== undefined) {
      if(info.currentUser.role_id !== RoleEnum.AGENT) {
          setCanViewClient(true);
      } else {
        if(info.lead.agent_id == info.currentUser.id) {
          setCanViewClient(true);
        } else {
          setCanViewClient(false);
        }
      }
    }
  }, [info.lead, info.currentUser]);

  const closeModal = () => {
    onClose();
  };

  const viewClient = () => {
    closeModal();
    navigate(UpdateLeadPath, { state: { lead: info.lead! } });
  }

  return (
    <ModalInformation
      isOpen={info.show}
      onClose={closeModal}
      cancelButton={true}
      label={t("LEAD_INFORMATION")}
      saveButton={ canViewClient ? {
        label: t("VIEW_LEAD"),
        onClick: viewClient,
        icon: <EyeIcon/>
      } : undefined }
    >
      <div className="w-full flex flex-wrap my-3">
        <div className="w-full px-3 md:w-1/3 mb-4">
          <label className="block tracking-wide text-sm text-gray-700">
            {t("FIRST_NAME")}
          </label>
          <label className="text-black font-medium">
            {info.lead?.first_name}
          </label>
        </div>
        <div className="w-full px-3 md:w-1/3 mb-4">
          <label className="block tracking-wide text-gray-700 text-sm">
            {t("LAST_NAME")}
          </label>
          <label className="text-black font-medium">
            {info.lead?.last_name}
          </label>
        </div>
        <div className="w-full px-3 md:w-1/3 mb-4">
          <label className="block tracking-wide text-gray-700 text-sm">
            {t("DATE_OF_BIRTH")}
          </label>
          <label className="text-black font-medium">
            {docDateFormat(`${info.lead?.dob}`)}
          </label>
        </div>
        <div className="w-full px-3 md:w-1/3 mb-4">
          <label className="block tracking-wide text-gray-700 text-sm">
            {t("PHONE")}
          </label>
          <label className="text-black font-medium">
            {info.lead?.phone}
          </label>
        </div>
        <div className="w-full px-3 md:w-1/3 mb-4">
          <label className="block tracking-wide text-gray-700 text-sm">
            {t("EMAIL")}
          </label>
          <label className="text-black font-medium">
            {info.lead?.email}
          </label>
        </div>
      </div>
    </ModalInformation>
  );
};